import { singleton } from 'tsyringe';
import imageCompression from 'browser-image-compression';

@singleton()
export class ImageService {
    async 压缩图片(
        file: File,
        options: {
            最大体积MB?: number;
            最大宽或高px?: number;
            目标类型?: string;
        }
    ): Promise<Blob> {
        const compression_options = {
            maxSizeMB: options.最大体积MB,
            maxWidthOrHeight: options.最大宽或高px,
            fileType: 'image/jpeg',
        };
        try {
            return await imageCompression(file, compression_options);
        } catch (error) {
            throw Error(`压缩图片发生错误：${error}`);
        }
    }
}
